/* eslint-disable */
import React, { useEffect, useState } from 'react';
import TreeView from 'react-treeview';
import getFileIcon from '../../utils/getFileIcon';

const getFileType = (name, isUrl) => {
  if (isUrl) return 'URL';
  const parts = (name || '').split('.');
  if (parts.length < 2) return 'ФАЙЛ';
  return parts.pop().toUpperCase();
};

// numeric: true — названия начинаются с номера (" 1 Факультет", "10 кафедра"),
// без него строковое сравнение даёт порядок 1, 10, 11, 2
const byName = (getter, asc) => (a, b) => {
  const res = (getter(a) || '').trim().localeCompare((getter(b) || '').trim(), 'ru', {
    sensitivity: 'base',
    numeric: true,
  });
  return asc ? res : -res;
};

// Название подразделения приходит с ведущим номером, напр. " 1 Факультет ...".
// Вычленяем номер для бейджа и оставляем остальное как название.
const splitFaculty = (faculty) => {
  const m = (faculty || '').match(/^\s*(\d+)\s*(.*)$/);
  if (m) return { num: m[1], name: (m[2] || '').trim() || (faculty || '').trim() };
  return { num: '', name: (faculty || '').trim() };
};

const MetoRoom = (props) => {
  const {
    facultyList,
    methodical,
    content,
    match,
    fetchFaculties,
    fetchMethodical,
    fetchContent,
    openFileInTab,
  } = props;

  const [activeId, setActiveId] = useState(null);
  const [activeFolderId, setActiveFolderId] = useState(null);
  const [deptSearch, setDeptSearch] = useState('');
  const [deptSortAsc, setDeptSortAsc] = useState(true);
  const [fileSearch, setFileSearch] = useState('');
  const [fileSortAsc, setFileSortAsc] = useState(true);

  useEffect(() => {
    fetchFaculties();
    window.scrollTo(0, 0);
  }, []);

  const onDepartmentClick = (faculty) => {
    const id = faculty.idfaculty;
    setActiveId(id);
    setActiveFolderId(null);
    setFileSearch('');
    fetchMethodical(id);
  };

  const onFolderClick = (elem) => {
    const mrId = elem.mrid;
    setActiveFolderId(mrId);
    setFileSearch('');
    fetchContent(activeId, mrId);
  };

  const openFile = (elem) => {
    if (elem.mr_isfile === 2) {
      window.open(encodeURI((elem.url || '').replace(/\\/g, '/')), '_blank', 'noopener,noreferrer');
    } else {
      openFileInTab(activeId, elem.mrid, elem.mr_name);
    }
  };

  const Children = (elem) => {
    const activeClass = activeFolderId === elem.mrid ? 'active-elem' : '';
    return (
      <div className="tree-view">
        <div className="tree-view_item">
          <p
            onClick={() => onFolderClick(elem)}
            className={`folder_with-line meto_room__pointer ${activeClass}`}
          >
            {elem.mr_name}
          </p>
        </div>
      </div>
    );
  };

  const Parent = (elem, i) => {
    const activeClass = activeFolderId === elem.mrid ? 'active-elem' : '';
    return (
      <TreeView
        nodeLabel={<div className={`folder_with-line meto_room__pointer ${activeClass}`}
          onClick={() => onFolderClick(elem)}>{elem.mr_name}</div>} key={i}
        defaultCollapsed={false} >
        <div className="tree__noun">
          {elem.children.map((structure, key) => TreeChild(structure, key))}
        </div>
      </TreeView>
    );
  };

  const TreeChild = (c, i) => (
    <div key={i}>
      {c.children.length > 0 ? Parent(c, i) : Children(c, i)}
    </div>
  );

  const renderFile = (elem) => {
    const isUrl = elem.mr_isfile === 2;
    const isFile = elem.mr_isfile === 1;
    if (!isUrl && !isFile) return null;

    const type = getFileType(elem.mr_name, isUrl);
    const iconSrc = getFileIcon(isUrl ? 'url' : elem.mr_name);
    return (
      <div
        className="emk-file"
        key={elem.mrid}
        onClick={() => openFile(elem)}
      >
        <span className="emk-file__main">
          <img className="emk-file__icon" src={iconSrc} alt="" />
          <span className="emk-file__name">{elem.mr_name}</span>
        </span>
        <span className="emk-file__type">{type}</span>
      </div>
    );
  };

  const captionText = match.path === '/library'
    ? 'Библиотека электронных образовательных материалов'
    : 'Электронный методический кабинет';

  const departments = (facultyList || [])
    .filter(f => (f.faculty || '').toLowerCase().includes(deptSearch.trim().toLowerCase()))
    .sort(byName(f => f.faculty, deptSortAsc));

  const files = (content || [])
    .filter(f => (f.mr_name || '').toLowerCase().includes(fileSearch.trim().toLowerCase()))
    .sort(byName(f => f.mr_name, fileSortAsc));

  return (
    <div className="emk">
      <div className="captions h1">{captionText}</div>

      <div className="emk__workspace">
        <section className="emk__panel emk__panel--dept">
          <div className="emk__panel-head">
            <span className="emk__panel-title">Подразделения</span>
            <button
              type="button"
              className="emk__sort"
              onClick={() => setDeptSortAsc(!deptSortAsc)}
              title="Сортировка по названию"
            >
              {deptSortAsc ? 'А–Я ↑' : 'Я–А ↓'}
            </button>
          </div>
          <div className="emk__search-row">
            <input
              className="emk__search"
              type="search"
              placeholder="Поиск подразделения"
              value={deptSearch}
              onChange={e => setDeptSearch(e.target.value)}
            />
          </div>
          <div className="emk__scroll emk__dept-list">
            {departments.map(faculty => {
              const { num, name } = splitFaculty(faculty.faculty);
              return (
                <button
                  type="button"
                  key={faculty.idfaculty}
                  className={`emk-dept ${activeId === faculty.idfaculty ? 'is-active' : ''}`}
                  onClick={() => onDepartmentClick(faculty)}
                >
                  {num && <span className="emk-dept__num">{num}</span>}
                  <span className="emk-dept__name">{name}</span>
                </button>
              );
            })}
            {departments.length === 0 && (
              <div className="emk__empty">Ничего не найдено</div>
            )}
          </div>
        </section>

        <section className="emk__panel emk__panel--tree">
          <div className="emk__panel-head">
            <span className="emk__panel-title">Папки</span>
          </div>
          <div className="emk__scroll emk__tree">
            {methodical.map(TreeChild)}
            {methodical.length === 0 && (
              <div className="emk__empty">Выберите подразделение</div>
            )}
          </div>
        </section>

        <section className="emk__panel emk__panel--files">
          <div className="emk__panel-head">
            <span className="emk__panel-title">Файлы</span>
            <button
              type="button"
              className="emk__sort"
              onClick={() => setFileSortAsc(!fileSortAsc)}
              title="Сортировка по имени"
            >
              {fileSortAsc ? 'А–Я ↑' : 'Я–А ↓'}
            </button>
          </div>
          <div className="emk__search-row">
            <input
              className="emk__search"
              type="search"
              placeholder="Поиск в папке"
              value={fileSearch}
              onChange={e => setFileSearch(e.target.value)}
            />
          </div>
          <div className="emk-file__head">
            <span>Имя</span>
            <span>Тип</span>
          </div>
          <div className="emk__scroll emk__file-list">
            {files.map(renderFile)}
            {files.length === 0 && (
              <div className="emk__empty">Нет файлов</div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default MetoRoom;
